import { AuthState } from '@okta/okta-auth-js';

import { RefFuturesContracts } from '../../services/backend/RefFuturesContracts';
import { useBaseApiClient } from '../useBaseApiClient';

export const useRefFuturesContracts: () => RefFuturesContracts<AuthState> = () => {
  return useBaseApiClient(RefFuturesContracts);
};
